<template>
  <div class="md-layout-item md-size-50 md-small-size-100">
    <md-card>
      <md-card-header>
        <div class="md-title">{{ $t("message.aboutTitle") }}</div>
      </md-card-header>
      <md-card-content>
        <div class="md-content">© 2019</div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
export default {
  name: "About"
};
</script>
